import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import PaymentRequiredHandler from "./components/PaymentRequiredHandler";
import Router from "./components/Router/index";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { sweptTheme } from "./theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider theme={sweptTheme}>
    <SnackbarProvider
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={2500}
    >
      <CssBaseline />
      <RouterProvider router={Router} />
      <PaymentRequiredHandler />
    </SnackbarProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
